<template>
  <div :class="`menu ${borderRight && 'border_right'}`">
    <div v-show="title" class="title">{{title}}</div>
    <AntEmpty v-show="!data.length" />
    <a-menu>
      <a-menu-item v-for="(item,index) in data" :key="index">
        <span @click="$listeners.click(item)" class="item">{{item}}</span>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    data: { type: Array, default: () => [] },
    borderRight: { type: Boolean, default: false }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>